import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "image-viewer-container" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
    key: 2,
    class: "download-buttons-container mt-2 text-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.sourceType === 'svg')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "svg-wrapper",
                ref: "svgElementRef",
                innerHTML: _ctx.sanitizedSvg,
                style: _normalizeStyle(_ctx.viewerStyle)
            }, null, 12, _hoisted_2))
            : (_ctx.sourceType === 'png-datauri' || _ctx.sourceType === 'png-url')
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.source,
                    ref: "pngElementRef",
                    alt: "Image",
                    class: "png-image",
                    style: _normalizeStyle(_ctx.viewerStyle),
                    onLoad: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.adjustImageDimensions && _ctx.adjustImageDimensions(...args))),
                    onError: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => (_ctx.onImageError && _ctx.onImageError(...args)))
                }, null, 44, _hoisted_3))
                : _createCommentVNode("", true),
        (_ctx.showDownloadButtons && (_ctx.sourceType === 'svg' || _ctx.sourceType === 'png-datauri' || _ctx.sourceType === 'png-url'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_ctx.sourceType === 'svg')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("button", {
                            onClick: _cache[2] || (_cache[2] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.downloadSvg && _ctx.downloadSvg(...args)), ["prevent"])),
                            class: "badge rounded-pill btn btn-sm btn-primary me-2"
                        }, "Download SVG"),
                        _createElementVNode("button", {
                            onClick: _cache[3] || (_cache[3] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.downloadPngFromSvg && _ctx.downloadPngFromSvg(...args)), ["prevent"])),
                            class: "badge rounded-pill btn btn-sm btn-primary me-2"
                        }, "Download PNG"),
                        _createElementVNode("button", {
                            onClick: _cache[4] || (_cache[4] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.copySvgText && _ctx.copySvgText(...args)), ["prevent"])),
                            class: "badge rounded-pill btn btn-sm btn-primary"
                        }, "Copy SVG")
                    ], 64))
                    : (_ctx.sourceType === 'png-datauri' || _ctx.sourceType === 'png-url')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("button", {
                                onClick: _cache[5] || (_cache[5] = _withModifiers(
                                //@ts-ignore
                                (...args) => (_ctx.downloadPngFromPngSource && _ctx.downloadPngFromPngSource(...args)), ["prevent"])),
                                class: "badge rounded-pill btn btn-sm btn-primary me-2"
                            }, "Download PNG"),
                            _createElementVNode("button", {
                                onClick: _cache[6] || (_cache[6] = _withModifiers(
                                //@ts-ignore
                                (...args) => (_ctx.copyPngImage && _ctx.copyPngImage(...args)), ["prevent"])),
                                class: "badge rounded-pill btn btn-sm btn-primary"
                            }, "Copy Image")
                        ], 64))
                        : _createCommentVNode("", true)
            ]))
            : _createCommentVNode("", true)
    ]));
}
